import { z } from 'zod'

/**
 * 寬鬆的 email 正規表達式
 * 只檢查基本格式：xxx@xxx.xxx
 * - 至少有一個 @ 符號
 * - @ 前後都有非空白字元
 * - @ 後方有至少一個 .
 * - . 後方有非空白字元
 */
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/**
 * 必填的 email 驗證 schema
 * 用於新增使用者時的 email 欄位
 */
export function emailSchema() {
  return z
    .string()
    .min(1, { message: '請輸入 Email' })
    .refine((val) => emailRegex.test(val), { message: 'Email 格式不正確' })
}

/**
 * 選填的 email 驗證 schema
 * 用於編輯使用者或 email 為選填的場景
 */
export function optionalEmailSchema() {
  return z
    .string()
    .refine((val) => val === '' || emailRegex.test(val), { message: 'Email 格式不正確' })
    .optional()
    .or(z.literal(''))
}
